var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTelegramIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    width: "32px",
    height: "32px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface56182022"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(80.000001%,80.000001%,80.000001%)",
      fillOpacity: 1
    },
    d: "M 16 32 C 7.164062 32 0 24.835938 0 16 C 0 7.164062 7.164062 0 16 0 C 24.835938 0 32 7.164062 32 16 C 32 24.835938 24.835938 32 16 32 Z M 16 32 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(47.450981%,33.333334%,23.921569%)",
      fillOpacity: 1
    },
    d: "M 16 0.132812 C 7.238281 0.132812 0.132812 7.238281 0.132812 16 C 0.132812 24.761719 7.238281 31.867188 16 31.867188 C 24.761719 31.867188 31.867188 24.761719 31.867188 16 C 31.867188 7.238281 24.761719 0.132812 16 0.132812 Z M 16 0.132812 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 23.894531 8.859375 L 20.921875 24.035156 C 20.921875 24.035156 20.792969 24.726562 19.933594 24.726562 C 19.476562 24.726562 19.242188 24.507812 19.242188 24.507812 L 12.804688 19.167969 L 9.65625 17.582031 L 5.613281 16.503906 C 5.613281 16.503906 4.894531 16.296875 4.894531 15.703125 C 4.894531 15.207031 5.632812 14.96875 5.632812 14.96875 L 22.542969 8.253906 C 22.542969 8.25 23.0625 8.066406 23.4375 8.066406 C 23.667969 8.066406 23.933594 8.164062 23.933594 8.464844 C 23.933594 8.660156 23.894531 8.859375 23.894531 8.859375 Z M 23.894531 8.859375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(69.01961%,74.509805%,77.254903%)",
      fillOpacity: 1
    },
    d: "M 15.207031 21.160156 L 12.488281 23.835938 C 12.488281 23.835938 12.371094 23.929688 12.210938 23.933594 C 12.15625 23.933594 12.097656 23.925781 12.039062 23.898438 L 12.804688 19.167969 Z M 15.207031 21.160156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(81.176472%,84.705883%,86.274511%)",
      fillOpacity: 1
    },
    d: "M 20.679688 11.394531 C 20.542969 11.222656 20.296875 11.1875 20.121094 11.320312 L 9.652344 17.585938 C 9.652344 17.585938 11.324219 22.261719 11.578125 23.070312 C 11.835938 23.878906 12.039062 23.898438 12.039062 23.898438 L 12.804688 19.167969 L 20.605469 11.949219 C 20.777344 11.816406 20.8125 11.570312 20.679688 11.394531 Z M 20.679688 11.394531 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIcon);
export default __webpack_public_path__ + "static/media/telegram-icon.f73e4270f26fca9fefd0d4995c4f3997.svg";
export { ForwardRef as ReactComponent };